import clsx from 'clsx';
import type { ReactNode } from 'react';
import type { Responsive } from '../spacing/types.js';

export function UNSTABLE_Hidden({ children, hide }: { children: ReactNode; hide: Responsive<boolean> }) {
  const hiddenDataAttributes =
    typeof hide === 'object'
      ? Object.fromEntries(
          Object.entries(hide).map(([breakpoint, value]) => {
            return [`data-hidden-${breakpoint}`, value];
          }),
        )
      : {
          'data-hidden-sm': hide,
        };

  return (
    <div className={clsx('cim-hidden')} {...hiddenDataAttributes}>
      {children}
    </div>
  );
}
